import { Link } from "@tiptap/extension-link";

const LinkExtended = Link.extend({
  addOptions() {
    return {
      ...this.parent?.(),
      stylePreferences: {},
    }
  },

  renderHTML({ node, HTMLAttributes }) {
    const stylePrefs = this.options.stylePreferences;
    if (stylePrefs["a"]) {
      HTMLAttributes.style = stylePrefs["a"];
    }

    return this.parent?.({ node, HTMLAttributes });
  },
})

export default LinkExtended;
